export default "__VITE_ASSET__Dk50Aomd__"